import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://1777d4e2bc9d165b149c3db8dcd42766@o4509197598457856.ingest.us.sentry.io/4511215626027008",
  sendDefaultPii: true
});

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import store from './redux/store';

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let payload = urlParams.get('payload');

if (payload[payload.length - 1] === '/') { 
  payload = payload.slice(0,-1);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App payload={payload} />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
